import HeroBg from "public/kubernetes/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Deploy your  Kubernetes clusters today",
    link: "contact-us",
  },
  desc: "Deploy fully isolated private Kubernetes clusters for containerized applications with uncompromised security, flexibility, and automation.",
  title: "Secure & Scalable Kubernetes for Private Deployments",
  image: HeroBg,
};
